<template>
  <div v-if="parsedUsps && parsedUsps.length > 0" class="product-usps">
    <div class="product-usps__list">
      <div
        v-for="(usp, index) in parsedUsps"
        :key="index"
        class="product-usps__item">
        <oie-base-icon icon="checkmark-outline" size="s"></oie-base-icon>
        <span class="product-usps__text body">{{ usp.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    usps: {
      type: [Array, String],
      required: false,
      default: () => []
    }
  },
  computed: {
    parsedUsps() {
      if (!this.usps) {
        return []
      }
      if (Array.isArray(this.usps)) {
        return this.usps
      }
      try {
        return JSON.parse(this.usps)
      } catch (e) {
        console.error('Failed to parse USPs JSON:', this.usps, e)
        return []
      }
    }
  },
  watch: {
    usps: {
      handler(newVal) {
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.product-usps {
  margin: 0.5rem 0 0 0;
  padding: 0;
}

.product-usps__list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.product-usps__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #333;
  svg {
    fill: color(brand-blue-3);
  }
}

.product-usps__icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  color: #5e9b7c;
  margin-top: 0.125rem;
  flex-basis: 1.25rem;
}

.product-usps__icon-check {
  width: 100%;
  height: 100%;
}

.product-usps__text {
  flex: 1;
  color: #333;
  word-break: break-word;
}
</style>
